import React from "react";
import { NavLink } from "react-router-dom";

const MobileAvatarMenu = (props) => {
  return (
    <div className="mobile-menu-overlay">
      <NavLink hidden to="/editProfile" id="edit-profile-nav-link"></NavLink>
      <div
        className="mobile-menu-outline"
        onClick={() => props.CloseMenu()}
      ></div>
      <div className="mobile-avatar-menu">
        <section
          className="menu-item"
          onClick={() =>
            document.getElementById("edit-profile-nav-link").click()
          }
        >
          <i className="feather-user"></i>
          <p>Edit Profile</p>
        </section>
        <section
          className="menu-item"
          onClick={() => {
            window.localStorage.setItem("IsEditNotifications", 1);
            setTimeout(() => {
              document.getElementById("edit-profile-nav-link").click();
            }, 100);
          }}
        >
          <i className="feather-settings"></i>
          <p>Edit notifications</p>
        </section>
        <section className="menu-item" onClick={() => props.ToggleUpload()}>
          <i className="feather-camera"></i>
          <p>Edit Photo</p>
        </section>
      </div>
    </div>
  );
};

export default MobileAvatarMenu;
